import { render, staticRenderFns } from "./articItem.vue?vue&type=template&id=c8604602&scoped=true"
import script from "./articItem.vue?vue&type=script&lang=js"
export * from "./articItem.vue?vue&type=script&lang=js"
import style0 from "./articItem.vue?vue&type=style&index=0&id=c8604602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8604602",
  null
  
)

export default component.exports